export const FORMULAS_HTML_TAG = 'formula-chip';

export const FORMULAS_DELIMITER_PREFIX = '=FORMULA[';
export const FORMULAS_DELIMITER_SUFFIX = ']FORMULA=';

// Data Input Menu
const VALUE_IN_FIRST_ELEMENT = 'VALUE_IN_FIRST_ELEMENT';
const HTML_TO_TEXT = 'HTML_TO_TEXT';
const HTML_TO_MARKDOWN = 'HTML_TO_MARKDOWN';
const HTML_TO_HTML = 'HTML_TO_HTML';
const HTML_TO_MARKDOWN_FAKE = 'HTML_TO_MARKDOWN_FAKE';
const MARKDOWN_TO_HTML = 'MARKDOWN_TO_HTML';
const MARKDOWN_TO_TEXT = 'MARKDOWN_TO_TEXT';
const MARKDOWN_TO_MARKDOWN = 'MARKDOWN_TO_MARKDOWN';
const MARKDOWN_TO_MARKDOWN_FAKE = 'MARKDOWN_TO_MARKDOWN_FAKE';

const MERGE_INTO_COMMAS_KEY = 'MERGE_INTO_COMMAS';

export const FORMULAS_TO_RICH_TEXT = [MARKDOWN_TO_HTML, HTML_TO_HTML];

/* 
id: identifier
key: the key that we use in the insert data - the actual value
 */
export const FORMULAS = [
	{
		id: VALUE_IN_FIRST_ELEMENT,
		key: VALUE_IN_FIRST_ELEMENT,
		title: 'Use first item',
		icon: 'fx',
		tooltip: 'Always uses data from the first item in the collection',
	},
	{
		id: HTML_TO_TEXT,
		key: HTML_TO_TEXT,
		title: 'Html to text',
		icon: 'fx', //'html',
		tooltip: 'Convert Html to Text',
	},
	{
		id: HTML_TO_MARKDOWN,
		key: HTML_TO_MARKDOWN,
		title: 'Html to Markdown',
		icon: 'fx', //'html',
		tooltip: 'Convert Html to Markdown',
	},
	{
		id: HTML_TO_HTML,
		key: HTML_TO_HTML,
		title: 'Keep Html format',
		icon: 'fx', //'html',
		tooltip: 'Html style & structure will be applied',
	},
	{
		// ask if we want to see this as markdown but because the value is markdown and we have html it will automatically be markdown at the end
		id: HTML_TO_MARKDOWN_FAKE,
		key: HTML_TO_HTML,
		title: 'Html to Markdown',
		icon: 'fx', //'html',
		tooltip: 'Convert Html to Markdown',
	},
	{
		id: MARKDOWN_TO_HTML,
		key: MARKDOWN_TO_HTML,
		title: 'Markdown to Html',
		icon: 'fx', //'markdown',
		tooltip: 'Convert Markdown to Html',
	},
	{
		id: MARKDOWN_TO_TEXT,
		key: MARKDOWN_TO_TEXT,
		title: 'Markdown to Text',
		icon: 'fx', //'markdown',
		tooltip: 'Convert Markdown to Text',
	},
	{
		id: MARKDOWN_TO_MARKDOWN,
		key: MARKDOWN_TO_MARKDOWN,
		title: 'Keep markdown format',
		icon: 'fx', //'markdown',
		tooltip: 'Markdown style & structure will be applied',
	},
	{
		id: MARKDOWN_TO_MARKDOWN_FAKE,
		key: MARKDOWN_TO_HTML,
		title: 'Keep markdown format',
		icon: 'fx', //'markdown',
		tooltip: 'Markdown style & structure will be applied',
	},
	// { key: MERGE_INTO_COMMAS_KEY, title: 'Merge into comma separated values', icon: 'fx', tooltip: 'TBD' },
];

export const FORMULAS_KEYS = Object.freeze({
	VALUE_IN_FIRST_ELEMENT,
	HTML_TO_TEXT,
	HTML_TO_MARKDOWN,
	HTML_TO_MARKDOWN_FAKE,
	HTML_TO_HTML,
	MARKDOWN_TO_HTML,
	MARKDOWN_TO_TEXT,
	MARKDOWN_TO_MARKDOWN,
	MARKDOWN_TO_MARKDOWN_FAKE,
	MERGE_INTO_COMMAS_KEY,
});
